import React from 'react';
import { Box, Paper, Typography, Button, Container } from '@mui/material';
import equityLogo from '../assets/equity-logo.png';

// Direct login is disabled. The leaderboard is now exclusively available
// inside the Payd agent portal at paydhub.com.
const Login = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#F5F7F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(ellipse at center, rgba(44, 156, 108, 0.15) 0%, transparent 70%)',
          opacity: 0.5,
        },
      }}
    >
      <Container component="main" maxWidth="xs" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mb: 3 }}>
            <img src={equityLogo} alt="Equity Insurance Partners" style={{ height: 80 }} />
          </Box>
          <Typography component="h1" variant="h5" sx={{ color: '#2C9C6C', fontWeight: 700, mb: 1 }}>
            Access Moved
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            The leaderboard is now exclusively available inside your{' '}
            <strong>Payd agent portal</strong>. Direct login to this site is no longer supported.
          </Typography>
          <Button
            variant="contained"
            size="large"
            fullWidth
            href="https://paydhub.com"
            sx={{
              background: 'linear-gradient(135deg, #1F6F52 0%, #2C9C6C 100%)',
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 700,
              borderRadius: 2,
              '&:hover': { background: 'linear-gradient(135deg, #1a6048 0%, #259660 100%)' },
            }}
          >
            Go to Payd Portal →
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;
